module.exports = __webpack_public_path__ + "static/media/what-with-long-term-effect-table.de6636d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/help-and-guides/what-with-long-term-effect-table.png
// module id = 836
// module chunks = 0